interface GetSiteVerificationConnectionStatusParams {
    isAutomaticallyConnected: boolean;
    verificationCode?: string;
}

export interface SiteVerificationConnectionStatus {
    hasVerificationCode: boolean;
    isConnected: boolean;
}

export const getSiteVerificationConnectionStatus = ({
    isAutomaticallyConnected,
    verificationCode,
}: GetSiteVerificationConnectionStatusParams): SiteVerificationConnectionStatus => {
    const hasVerificationCode = Boolean(verificationCode?.trim());

    return {
        hasVerificationCode,
        isConnected: isAutomaticallyConnected || hasVerificationCode,
    };
};
